import { camelCase } from "lodash-es";

import { getSortOptionFromURI } from "components/Filters/helpers";
import { SearchQueryOrderDirection } from "types/generated";

import { FLOWS_PROJECTS_COLUMN_ID } from "./constants";
import { FlowsProjectRow } from "./types";

export const filterFlowsProjectsByName = (
  projects: FlowsProjectRow[],
  searchQuery: string
): FlowsProjectRow[] => {
  const query = searchQuery.toLocaleLowerCase();

  return projects.filter((project) => project.name.toLocaleLowerCase().includes(query));
};

export const sortFlowsProjects = (
  searchParams: URLSearchParams,
  projects: FlowsProjectRow[]
): FlowsProjectRow[] => {
  const [sortOption] = getSortOptionFromURI(
    searchParams,
    FLOWS_PROJECTS_COLUMN_ID.NAME,
    SearchQueryOrderDirection.Asc
  );

  const key = camelCase(sortOption.field) as keyof FlowsProjectRow;

  return [...projects].sort((a, b) => {
    const valueA = a[key];
    const valueB = b[key];

    if (typeof valueA === "string" && typeof valueB === "string") {
      return sortOption.direction === SearchQueryOrderDirection.Asc
        ? valueA.localeCompare(valueB, undefined, { numeric: true })
        : valueB.localeCompare(valueA, undefined, { numeric: true });
    }

    if (typeof valueA === "number" && typeof valueB === "number") {
      return sortOption.direction === SearchQueryOrderDirection.Asc
        ? valueA - valueB
        : valueB - valueA;
    }

    return 0;
  });
};
